import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Paper,
  InputAdornment,
  Typography,
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  MenuItem,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  withStyles,
} from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';

class Device extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isApply: false,
      isCheckAll: false,
      isChangeData: false,
      isSort: false,
      openFilterMenu: false,
      searchText: '',
      subgroupId: 0,
      tenantId: null,
      selectDevicesList: [],
      defaultSelectDevices: [],
      categories: [],
      subgroupsName: [],
      organizations: [],
      defaultOrganizations: [],
      take: 0,
      skip: 0,
      searchDevice: '',
      typingTimeout: 0,
    };
  }

  async componentDidMount() {
    console.log('componentDidMount from Device');
    const { tenantId } = this.props.tenant.toJS();
    const { data } = this.props.subGroup.toJS();
    if (tenantId) {
      await this.initData(tenantId);
      this.initOrganizationData([tenantId], data.moduleId);
    }
    this.initselectDevicesList(data.moduleId);
  }

  async initData(tenantId) {
    const { take } = this.state;
    this.props.devicePermission.setData('limit', take, false);
    this.props.devicePermission.setData('search', null, false);
    this.props.devicePermission.setData('filterOutStatus', ['NEW'], false);
    this.props.devicePermission.setData('tenantIds', [tenantId]);
  }

  async initselectDevicesList(id) {
    let subgroupIds = [];
    subgroupIds.push(id);

    await this.props.device.getDevicesBySubgroupIds(subgroupIds);

    const { devicesList } = this.props.device.toJS();
    let mapDevice = (devicesList || []).map((val) => {
      return {
        id: val.id ? val.id : '',
        label: val.id ? (val.name && val.name.length > 0 ? `${val.name} (${val.serial})` : val.serial) : '',
        name: val.name,
        serial: val.serial,
        type: val.deviceVersion ? val.deviceVersion.name : null,
        category: val.deviceVersion ? val.deviceVersion.category : '',
      };
    });

    this.setState({
      defaultSelectDevices: mapDevice,
    });

    this.onSortting(mapDevice, this.state.isSort);
  }

  async initOrganizationData(tenantIds, moduleId) {
    // const subgroupsName = [];
    let groups = await this.props.group.getGroupList(tenantIds);
    groups = (groups || []).map((g) => {
      // let count = 0;
      if (g.subGroups.length > 0) {
        g.subGroups = g.subGroups
          .filter((subgroup) => subgroup.id !== moduleId)
          .map((s) => {
            s.isChecked = false;
            return s;
          });
      }
      g.isChecked = false; //count === g.subGroups.length ? true : false;
      return g;
    });

    // filter groups has subgroups
    groups = groups.filter((g) => g.subGroups.length > 0);

    this.setState({
      // subgroupsName,
      subgroupId: moduleId,
      organizations: groups,
      defaultOrganizations: groups,
      isCheckAll:
        groups && groups.length === (groups || []).filter((group) => group.isChecked === true).length ? true : false,
    });
  }

  handleFinished = () => {
    const moduleStep = 3;
    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.props.wizard.setActiveStep(moduleStep);
          this.props.wizard.setActiveFlow('group');
          this.handleSetNavigation(moduleStep);
        }
      });
    } else {
      this.props.wizard.setActiveStep(moduleStep);
      this.props.wizard.setActiveFlow('group');
      this.handleSetNavigation(moduleStep);
    }
  };

  handleBack = () => {
    const moduleStep = 3;
    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.props.wizard.setActiveStep(moduleStep);
          this.props.wizard.setActiveFlow('group');
          this.handleSetNavigation(moduleStep);
        }
      });
    } else {
      this.props.wizard.setActiveStep(moduleStep);
      this.props.wizard.setActiveFlow('group');
      this.handleSetNavigation(moduleStep);
    }
  };

  handleResetData = async () => {
    const { tenantId } = this.props.tenant.toJS();
    const { data } = this.props.subGroup.toJS();
    if (tenantId) {
      await this.initData(tenantId);
      this.initOrganizationData([tenantId], data.moduleId);
    }
    this.initselectDevicesList(data.moduleId);
    this.setState({ isChangeData: false });
  };

  handleOpenedFilter = async () => {
    await this.props.deviceType.getCategory();
    this.setState({ openFilterMenu: !this.state.openFilterMenu });
  };

  handleFilter = async (event, category) => {
    const { checked } = event.target;
    let categories = [...this.state.categories];
    if (checked) {
      categories.push(category);
    } else {
      categories = categories.filter((c) => c !== category);
    }
    this.setState({ categories });
    this.props.devicePermission.filterDeviceCategory(categories);
  };

  handleChangeSort = () => {
    this.setState({
      isSort: !this.state.isSort,
    });

    const selected = [...this.state.selectDevicesList];
    this.onSortting(selected, !this.state.isSort);
  };

  onSortting = (data, status = false) => {
    if (status) {
      // order by desc
      // sort by label
      data.sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        if (labelA < labelB) {
          return 1;
        }
        if (labelA > labelB) {
          return -1;
        }
        return 0;
      });

      // sort by type
      data.sort((a, b) => {
        const typeA = a.type ? a.type.toLowerCase() : '';
        const typeB = b.type ? b.type.toLowerCase() : '';

        if (typeA < typeB) {
          return 1;
        } else if (typeA > typeB) {
          return -1;
        }
        return 0;
      });
    } else {
      // order by asc
      // sort by label
      data.sort((a, b) => {
        const labelA = a.label.toLowerCase(); // ignore upper and lowercase
        const labelB = b.label.toLowerCase(); // ignore upper and lowercase
        if (labelA < labelB) {
          return -1;
        } else if (labelA > labelB) {
          return 1;
        }
        return 0;
      });

      // sort by type
      data.sort((a, b) => {
        const typeA = a.type ? a.type.toLowerCase() : '';
        const typeB = b.type ? b.type.toLowerCase() : '';

        if (typeA < typeB) {
          return -1;
        } else if (typeA > typeB) {
          return 1;
        }
        return 0;
      });
    }

    this.setState({
      selectDevicesList: data,
    });
  };

  handleToggle(val) {
    let selected = [...this.state.selectDevicesList];
    const checkSelected = selected.find((data) => data.id === val.id);

    if (checkSelected) {
      selected = selected.filter((data) => data.id !== val.id);
    } else {
      selected.push(val);
    }

    this.setState({
      isChangeData: true,
      defaultSelectDevices: selected,
    });

    this.onSortting(selected, this.state.isSort);
  }

  handleSelectAll = (e) => {
    const { checked } = e.target;
    const selected = [];
    if (checked) {
      const { devices } = this.props.devicePermission.toJS();
      if (devices.data && devices.data.length > 0) {
        devices.data.forEach((device) => {
          selected.push(device);
        });
      }
    }

    this.setState({
      // selectDevicesList: selected,
      isChangeData: true,
      defaultSelectDevices: selected,
    });

    this.onSortting(selected, this.state.isSort);
  };

  handleDelete(val) {
    const selectDevicesList = this.state.selectDevicesList.filter((data) => data.id !== val.id);
    this.setState({
      selectDevicesList,
      isChangeData: true,
      defaultSelectDevices: selectDevicesList,
    });
  }

  handleSave = async () => {
    const { t } = this.props;
    const { defaultSelectDevices, subgroupId, organizations } = this.state;
    const subgroupIds = [];

    (organizations || []).forEach((data) => {
      (data.subGroups || []).forEach((s) => {
        if (s.isChecked) {
          subgroupIds.push(s.id);
        }
      });
    });
    subgroupIds.push(subgroupId);

    try {
      const result = await this.props.device.saveDevices(defaultSelectDevices, subgroupIds);
      if (result.statusCode === 200) {
        // Swal.fire({ html: `<h4>${t("assign_success")}`, type: "success" });
        this.setState({ isChangeData: false });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    }
  };

  handleSearch = async (task, value) => {
    const { categories } = this.state;
    this.props.devicePermission.setData('search', value, false);
    this.props.devicePermission.setData('offset', 0, false);

    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }

    this.setState({
      searchText: value,
      typingTimeout: setTimeout(async () => {
        await this.props.devicePermission.setData(task, value);
        this.props.devicePermission.filterDeviceCategory(categories);
      }, 1000),
    });
  };

  handleSearchDeviceInModule = async (value) => {
    this.setState({ searchDevice: value });
    const { defaultSelectDevices } = this.state;
    let searchResult = defaultSelectDevices;

    const search = value && value.toLowerCase();
    if (search && search.length > 0) {
      searchResult = (defaultSelectDevices || []).filter((device) => {
        if (device.label.toLowerCase().includes(search)) {
          return true;
        }
        return false;
      });
    }

    this.setState({ selectDevicesList: searchResult });
  };

  handleSearchByGroupOrModule = (e) => {
    const { value } = e.target;
    this.setState({ searchText: value });

    const search = value && value.toLowerCase();
    // const { groups } = this.props.group.toJS();
    const { defaultOrganizations } = this.state;
    let searchResult = defaultOrganizations;

    if (search && search.length > 0) {
      const tmp = (defaultOrganizations || []).filter((organization) => {
        if (organization.name.toLowerCase().includes(search)) {
          return true;
        } else if (organization.subGroups && organization.subGroups.length > 0) {
          return organization.subGroups.find((subgroup) => subgroup.name.toLowerCase().includes(search));
        }
        return false;
      });

      searchResult = tmp;
    }

    this.setState({ organizations: searchResult, isApply: true });
  };

  handleClickApply = () => {
    this.setState({ isApply: !this.state.isApply });
  };

  handleUnFocus = () => {
    this.setState({ isApply: false });
  };

  handleFocus = () => {
    this.setState({ isApply: true });
  };

  handleSelectAllGroup = (e) => {
    const { checked } = e.target;
    const { defaultOrganizations } = this.state;
    const subgroupsName = [];
    const groupslist = defaultOrganizations.map((group) => {
      group.isChecked = checked ? true : false;
      group.subGroups.map((subgroup) => {
        subgroup.isChecked = checked ? true : false;
        if (checked) {
          subgroupsName.push(subgroup.name);
        }
        return subgroup;
      });
      return group;
    });

    this.setState({
      subgroupsName,
      isChangeData: true,
      isCheckAll: checked,
      organizations: groupslist,
      defaultOrganizations: groupslist,
    });
  };

  handleChange = (e) => {
    let groups = [...this.state.organizations];
    const { value, name, checked } = e.target;
    let subgroupsName = [...this.state.subgroupsName];
    if (name === 'group') {
      groups = groups.map((val) => {
        if (val.id === +value) {
          val.isChecked = checked;
          (val.subGroups || []).map((item) => {
            item.isChecked = val.isChecked ? true : false;
            if (val.isChecked) {
              subgroupsName.push(item.name);
            } else {
              subgroupsName = subgroupsName.filter((name) => name !== item.name);
            }
            return item;
          });
        }
        return val;
      });
    }

    if (name === 'module') {
      groups.map((val) => {
        (val.subGroups || []).map((item) => {
          if (item.id === +value) {
            item.isChecked = checked ? true : false;
          }
          if (item.isChecked) {
            subgroupsName.push(item.name);
          } else {
            subgroupsName = subgroupsName.filter((name) => name !== item.name);
          }
          return item;
        });
        const findSubgroup = val.subGroups.find((item) => item.isChecked === false);
        val.isChecked = findSubgroup ? false : true;
        return val;
      });
    }

    const hasNotChecked = groups.filter((g) => g.isChecked === false);
    subgroupsName = [...new Set(subgroupsName)];
    this.setState({
      subgroupsName,
      organizations: groups,
      defaultOrganizations: groups,
      isChangeData: true,
      isCheckAll: hasNotChecked.length > 0 ? false : true,
    });
  };

  goToPage = (data) => {
    this.handleSetNavigation(data.wizardStep);
    this.props.wizard.setActiveStep(data.wizardStep);
  };

  handleSetNavigation = (step) => {
    const { navigations } = this.props.wizard.toJS();
    navigations.forEach((nav) => {
      if (nav.wizardPage === 'unit') {
        nav.wizardName = 'wizard_step_unit';
      }
    });
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
  };

  render() {
    const { classes, t } = this.props;
    const { selectDevicesList, subgroupsName, organizations, isCheckAll, defaultSelectDevices, isSort } = this.state;
    const { navigations } = this.props.wizard.toJS();
    const { categories } = this.props.deviceType.toJS();
    const { devices, search } = this.props.devicePermission.toJS();
    const isSelectAllDevices =
      devices.data && devices.data.length > 0 && defaultSelectDevices.length === devices.data.length;
    return (
      <div>
        <Grid container>
          <Grid container item sm={12}>
            {(navigations || []).map((nav, i) => (
              <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
                {' '}
                {t(`${nav.wizardName}`)}
                {' > '}
              </div>
            ))}
            <div className={classes.activeNav}>{t('wizard_device_management')}</div>
          </Grid>
          <Grid container item sm={12}>
            <div className={classes.textHeader}>{t('wizard_device_of')}</div>
            <div className={classes.textHeaderPrimary}>{/* {navigations[3].wizardName} */}</div>
          </Grid>
          <Grid container item sm={6} alignItems='center' />
          <Grid container item sm={6} alignItems='center'>
            <Grid item sm={2}>
              <div>{t('apply_to')}:</div>
            </Grid>
            <Grid item sm={10} style={{ position: 'relative' }}>
              <TextField
                id='select'
                name='select'
                variant='outlined'
                margin='dense'
                fullWidth
                placeholder={t('wizard_select_module_same')}
                value={subgroupsName}
                className={classes.textField}
                onClick={this.handleClickApply}
                InputProps={{
                  className: classes.input,
                  endAdornment: (
                    <InputAdornment position='end'>
                      <Icons.ArrowDropDown style={{ color: '#d7d7d7' }} />
                    </InputAdornment>
                  ),
                }}
              />
              <div className={classes.wrapPaper} style={{ display: this.state.isApply ? 'block' : 'none' }}>
                <Paper
                  className={classes.paper}
                  onMouseEnter={() => this.handleFocus()}
                  onMouseLeave={() => this.handleUnFocus()}
                >
                  <TextField
                    id='search'
                    name='search'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    value={this.state.searchText}
                    placeholder={t('wizard_search_by_organization_and_module')}
                    onChange={(e) => this.handleSearchByGroupOrModule(e)}
                    className={classes.textField}
                    InputProps={{
                      className: classes.input,
                      startAdornment: (
                        <InputAdornment position='start'>
                          {' '}
                          <svg width='24' height='24' viewBox='0 0 24 24'>
                            <use xlinkHref={`/images/menus-v1.svg#search`} />
                          </svg>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <List className={classes.boxContent}>
                    <ListItem dense button>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          id='checkbox-select-all'
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={isCheckAll ? true : false}
                          onChange={(e) => this.handleSelectAllGroup(e)}
                        />
                      </ListItemIcon>
                      <ListItemText className={classes.labelCheckBox} id='all' primary={t('select_all')} />
                    </ListItem>
                    {(organizations || []).map((val) => {
                      return (
                        <div key={val.id}>
                          <ListItem key={val.id} dense button>
                            <ListItemIcon style={{ marginRight: '0px' }}>
                              <Checkbox
                                id={`${val.id}`}
                                style={{ padding: '0px' }}
                                color='primary'
                                edge='start'
                                name='group'
                                value={`${val.id}`}
                                checked={val.isChecked}
                                onChange={(e) => this.handleChange(e)}
                              />
                            </ListItemIcon>
                            <ListItemText
                              className={classes.labelCheckBox}
                              id={`checkbox-list-label-${val.id}`}
                              primary={`${val.name} (${t('select_all')})`}
                            />
                          </ListItem>
                          {(val.subGroups || []).map((subgroup) => (
                            <ListItem key={subgroup.id} dense button style={{ marginLeft: '25px' }}>
                              <ListItemIcon style={{ marginRight: '0px' }}>
                                <Checkbox
                                  id={`${subgroup.id}`}
                                  style={{ padding: '0px' }}
                                  color='primary'
                                  edge='start'
                                  name='module'
                                  value={`${subgroup.id}`}
                                  checked={subgroup.isChecked}
                                  onChange={(e) => this.handleChange(e)}
                                />
                              </ListItemIcon>
                              <ListItemText
                                className={classes.labelCheckBox}
                                id={`checkbox-list-label-${subgroup.id}`}
                                primary={`${subgroup.name}`}
                              />
                            </ListItem>
                          ))}
                        </div>
                      );
                    })}
                  </List>
                </Paper>
              </div>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={16} className={classes.wrapDeviceList}>
          <Grid item xs={6} sm={6}>
            <Paper className={classes.paperTable}>
              <Grid container className={classes.titleSpace}>
                <Grid container item xs={12} sm={7} alignItems='center'>
                  <Typography className={classes.textTitle}>{t('all_devices')}</Typography>
                  <label
                    className='badge badge-base'
                    style={{
                      display: 'flex',
                      height: 22,
                      alignItems: 'center',
                    }}
                  >
                    {devices.data && devices.data.length} {t('devices')}
                  </label>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    id='search'
                    name='search'
                    variant='outlined'
                    margin='dense'
                    placeholder={t('wizard_search_device')}
                    fullWidth
                    value={search || ''}
                    onChange={(e) => this.handleSearch('search', e.target.value)}
                    className={classes.textField}
                    InputProps={{
                      className: classes.input,
                      startAdornment: (
                        <InputAdornment position='start'>
                          {' '}
                          <svg width='20' height='20' viewBox='0 0 24 24'>
                            <use xlinkHref={`/images/menus-v1.svg#search`} />
                          </svg>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <div style={{ overflow: 'auto', height: '436px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ border: 'none', height: 44 }}>
                      <CustomTableCell>
                        <Checkbox
                          id='checkbox-all-device'
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={isSelectAllDevices ? true : false}
                          indeterminate={selectDevicesList.length === 0 || isSelectAllDevices ? false : true}
                          indeterminateIcon={<Icons.IndeterminateCheckBox color='primary' />}
                          inputProps={{
                            'aria-label': 'checkbox-list-label-all',
                          }}
                          onClick={(e) => this.handleSelectAll(e)}
                        />
                      </CustomTableCell>
                      <CustomTableCell>{t('device_name')}</CustomTableCell>
                      <CustomTableCell>
                        <Grid container alignItems='center' style={{ position: 'relative' }}>
                          {t('wizard_device_type')}
                          <IconButton
                            id='filter-icon'
                            onClick={() => this.handleOpenedFilter()}
                            className={classes.btnIcon}
                          >
                            <svg width='16' height='16' viewBox='0 0 16 16'>
                              <use xlinkHref={`/images/menus-v1.svg#filter`} />
                            </svg>
                          </IconButton>
                          <div
                            className={classes.filterDeviceBox}
                            style={{ display: this.state.openFilterMenu ? 'block' : 'none' }}
                          >
                            <div
                              style={{
                                position: 'relative',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {categories.map((c) => (
                                <MenuItem key={c.value} id={`${c.value}`} value={c.value} style={{ padding: '8px' }}>
                                  <ListItemIcon style={{ marginRight: '0px' }}>
                                    <Checkbox
                                      id={`filter-${c.value}`}
                                      color='primary'
                                      onClick={(e) => this.handleFilter(e, c.value)}
                                    />
                                  </ListItemIcon>
                                  <label
                                    style={{ display: 'flex', alignItems: 'center', padding: '0px 11px' }}
                                    className={`badge ${
                                      c.value === 'EMERGENCY_BUTTON'
                                        ? 'badge-wizard-error'
                                        : c.value === 'AIRNODE'
                                          ? 'badge-wizard-info'
                                          : 'badge-wizard-indigo'
                                    }`}
                                  >
                                    <span className='dot' style={{ top: 10 }} />
                                    {c.label}
                                  </label>
                                </MenuItem>
                              ))}
                            </div>
                          </div>
                        </Grid>
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(devices.data || []).map((device, i) => (
                      <TableRow key={i}>
                        <CustomTableCell component='th' scope='row'>
                          <Grid container alignItems='center'>
                            <Checkbox
                              id={`checkbox-list-label-device-${device.id}`}
                              style={{ padding: '0px' }}
                              color='primary'
                              edge='start'
                              checked={defaultSelectDevices.find((data) => data.id === device.id) ? true : false}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                'aria-labelledby': `checkbox-list-label-${device.id}`,
                              }}
                              onClick={() => this.handleToggle(device)}
                            />
                          </Grid>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <div className={classes.deviceLabel}>{device.label}</div>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' style={{ fontSize: 12, width: 240 }}>
                          {device.type && (
                            <label
                              className={`badge ${
                                device.category === 'EMERGENCY_BUTTON'
                                  ? 'badge-wizard-error'
                                  : device.category === 'AIRNODE'
                                    ? 'badge-wizard-info'
                                    : 'badge-wizard-indigo'
                              }`}
                            >
                              <span className='dot' />
                              {device.type}
                            </label>
                          )}
                        </CustomTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>

          <Grid item xs={6} sm={6}>
            <Paper className={classes.paperTable}>
              <Grid container className={classes.titleSpace}>
                <Grid container item xs={12} sm={7} alignItems='center'>
                  <Typography className={classes.textTitle}>
                    {t('wizard_device_of')}
                    {/* {navigations[3].wizardName} */}
                  </Typography>
                  <label
                    className='badge badge-base'
                    style={{
                      display: 'flex',
                      height: 22,
                      alignItems: 'center',
                    }}
                  >
                    {selectDevicesList.length} {t('devices')}
                  </label>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    id='search-selected-device'
                    name='search'
                    variant='outlined'
                    margin='dense'
                    placeholder={t('wizard_search_device')}
                    fullWidth
                    value={this.state.searchDevice || ''}
                    onChange={(e) => this.handleSearchDeviceInModule(e.target.value)}
                    className={classes.textField}
                    InputProps={{
                      className: classes.input,
                      startAdornment: (
                        <InputAdornment position='start'>
                          {' '}
                          <svg width='20' height='20' viewBox='0 0 24 24'>
                            <use xlinkHref={`/images/menus-v1.svg#search`} />
                          </svg>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <div style={{ overflow: 'auto', height: '436px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ border: 'none', height: 44 }}>
                      <CustomTableCell component='th' scope='row' />
                      <CustomTableCell>{t('device_name')}</CustomTableCell>
                      <CustomTableCell>
                        <Grid container alignItems='center'>
                          {t('wizard_device_type')}
                          <IconButton
                            id='sort'
                            onClick={() => this.handleChangeSort()}
                            className={classes.btnIcon}
                            style={{ transform: isSort ? 'rotate(180deg)' : 'rotate(0deg)' }}
                          >
                            <svg width='16' height='16' viewBox='0 0 16 16'>
                              <use xlinkHref={`/images/menus-v1.svg#arrow-down`} />
                            </svg>
                          </IconButton>
                        </Grid>
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(selectDevicesList || []).map((device, i) => (
                      <TableRow key={i}>
                        <CustomTableCell component='th' scope='row'>
                          <IconButton
                            id={`delete-${device.id}`}
                            style={{ padding: '0px' }}
                            edge='end'
                            aria-label='delete'
                            onClick={() => this.handleDelete(device)}
                          >
                            <ClearIcon />
                          </IconButton>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <div className={classes.deviceLabel}>{device.label}</div>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' style={{ fontSize: 12 }}>
                          {device.type && (
                            <label
                              className={`badge ${
                                device.category === 'EMERGENCY_BUTTON'
                                  ? 'badge-wizard-error'
                                  : device.category === 'AIRNODE'
                                    ? 'badge-wizard-info'
                                    : 'badge-wizard-indigo'
                              }`}
                            >
                              <span className='dot' />
                              {device.type}
                            </label>
                          )}
                        </CustomTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              id='back'
              variant='outlined'
              color='primary'
              onClick={this.handleBack}
              style={{ marginRight: 10 }}
              className={classes.btnPrimary}
            >
              {t('back')}
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {this.state.isChangeData && (
              <Button
                id='reset'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                onClick={this.handleResetData}
                className={classes.btnPrimary}
              >
                {t('wizard_reset_data')}
              </Button>
            )}
            {this.state.isChangeData && (
              <Button
                id='save'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                className={classes.btnPrimary}
                onClick={this.handleSave}
              >
                {t('save')}
              </Button>
            )}
            <Button
              id='finish'
              variant='contained'
              color='primary'
              onClick={this.handleFinished}
              className={classes.btnPrimary}
            >
              {t('wizard_finish')}
            </Button>
          </div>
        </Grid>
      </div>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F9FAFB',
    color: '#667085',
    border: 'none',
    fontSize: 12,
    fontWeight: 500,
    borderTop: '1px solid #EAECF0',
    borderBottom: '1px solid #EAECF0',
    padding: '4px 4px 4px 12px',
  },
  body: {
    fontSize: 14,
    borderTop: '1px solid #EAECF0',
    borderBottom: 'none',
    padding: '4px 4px 4px 12px',
  },
}))(TableCell);

const styles = (theme) => ({
  root: {
    '&$indeterminate': {
      color: 'red',
    },
  },
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  textTitle: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 18,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '60%',
  },
  titleSpace: {
    alignItems: 'center',
    padding: '10px 20px 5px',
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
    fontSize: 14,
  },
  input: {
    color: theme.palette.text.primary,
    height: 36,
    marginTop: '-4px',
  },
  wrapPaper: {
    position: 'absolute',
    zIndex: 1,
    width: '100%',
  },
  paper: {
    padding: '20px 10px',
  },
  wrapDeviceList: {
    marginTop: 20,
  },
  muitiSelect: {
    border: '1px solid #D7D7D7',
    borderRadius: '4px',
    position: 'relative',
    height: 450,
  },
  muitiSelectNoBorder: {
    marginBottom: '35px',
  },
  boxContent: {
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 320,
  },
  boxSelected: {
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 380,
  },
  labelCheckBox: {
    paddingLeft: '5px',
    fontSize: '16px',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  paperTable: {
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
    border: '1px solid #EAECF0',
    borderRadius: '4px',
  },
  btnIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  filterDeviceBox: {
    position: 'absolute',
    zIndex: 10,
    width: '210px',
    border: '1px solid #F2F4F7',
    boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    top: 35,
  },
  deviceLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100px',
    },
  },
});

export const page = inject(
  'wizard',
  'tenant',
  'group',
  'subGroup',
  'device',
  'deviceType',
  'devicePermission',
)(observer(Device));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
